import { Helpers } from "@/global-scripts/helpers";
import ClickEvent = JQuery.ClickEvent;

/* eslint-disable-next-line */
(window as any).Menu = {
  opts: {
    menuOpenClass: "menu-open",
  },

  init: function () {
    this.body = $("body");
    this.menuToggle = $("#menu-toggle");
    this.setListeners();
  },

  setListeners: function () {
    this.menuToggle.click((e: ClickEvent) => {
      e.preventDefault();
      this.body.toggleClass(this.opts.menuOpenClass);

      if (this.body.hasClass(this.opts.menuOpenClass)) {
        Helpers.setScrollBarOffset();
      } else {
        Helpers.removeScrollBarOffset();
      }
    });

    $(window).on("resize", () => {
      if (this.body.hasClass(this.opts.menuOpenClass)) {
        this.body.removeClass(this.opts.menuOpenClass);
        Helpers.removeScrollBarOffset();
      }
    });

    $("#footer-scroll-top").click((e: ClickEvent) => {
      e.preventDefault();
      Helpers.scrollToTop();
    });
  },
};

$(function () {
  /* eslint-disable-next-line */
  (window as any).Menu.init();
});
